/** classes */
import { DsFormInstance } from './ds-form-instance';
import { DsFormTemplateSchemaWithTree } from './ds-form-template-schema-with-tree';
/** end classes */

/** interfaces */
import { DsFormInstanceWithTemplateInterface } from '../interfaces/form-instance/ds-form-instance-with-template.interface';
/** end interfaces */

export class DsFormInstanceWithTemplate extends DsFormInstance {
  /**
   *
   */
  public templateSchema: DsFormTemplateSchemaWithTree;

  /**
   * Creates an instance of DsFormInstanceWithTemplate.
   *
   * @param json the json data
   */
  constructor(json: DsFormInstanceWithTemplateInterface) {
    super(json);

    this.templateSchema = json.template_schema ? new DsFormTemplateSchemaWithTree(json.template_schema) : null;
  }
}
